import { render } from "./VideoEmbed.vue?vue&type=template&id=94514bbc&scoped=true"
import script from "./VideoEmbed.vue?vue&type=script&lang=js"
export * from "./VideoEmbed.vue?vue&type=script&lang=js"

import "./VideoEmbed.vue?vue&type=style&index=0&id=94514bbc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94514bbc"]])

export default __exports__